var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgeBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 7.58334H4.33366C3.13704 7.58334 2.16699 8.55339 2.16699 9.75V20.5833C2.16699 21.78 3.13704 22.75 4.33366 22.75H21.667C22.8636 22.75 23.8337 21.78 23.8337 20.5833V9.75C23.8337 8.55339 22.8636 7.58334 21.667 7.58334Z",
    stroke: "#848588",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 22.75V5.41667C17.3337 4.84203 17.1054 4.29093 16.6991 3.8846C16.2927 3.47827 15.7416 3.25 15.167 3.25H10.8337C10.259 3.25 9.70792 3.47827 9.30159 3.8846C8.89527 4.29093 8.66699 4.84203 8.66699 5.41667V22.75",
    stroke: "#848588",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/KnowledgeBase.3147ddaabe5506207e994f7b5d4ac908.svg";
export { ForwardRef as ReactComponent };